import styled from 'styled-components'

// Import themes modules
import { FlexBox, BoxImage } from '../../common/Box'

// Import common component
import Icon from '../../common/Icon'
import Title from '../../common/Title'
import Description from '../../common/Description'
import { Col3, Col6 } from '../../common/Grid'

// Themes
import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'
import TYPOGRAPHY from '../../../themes/Typography'

export const Wrapper = Col3.extend`
  margin: 0 ${px2Rem(2.5)};
`

export const StatitisWrapper = Col6.extend`
  padding: ${px2Rem(1)};
`

export const StatitisColWrapper = FlexBox.extend`
  padding: ${px2Rem(2.5)} 0 ${px2Rem(2.5)} ${px2Rem(5)};
  background: ${COLORS.white};

  div:first-child {
    margin-left: 0;
  }

  div:last-child {
    margin-right: 0;
  }
`

export const StatitisImage = BoxImage.extend`
  height: ${px2Rem(220)};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin: ${px2Rem(5)} 0;
`

export const LinkMore = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: ${COLORS.white};
  width: 100%;
  background-color: ${COLORS.red};
  height: ${px2Rem(120)};

  :hover {
    opacity: 0.8;
  }

  @media(min-width: 768px) {
    height: ${px2Rem(220)};
    margin: ${px2Rem(2.5)} 0;
  }
`

export const ContentMore = styled.span`
  font-family: ${TYPOGRAPHY.TYPE.bold};
  width: ${px2Rem(93)};
  font-size: ${TYPOGRAPHY.SIZE.xTiny};
  line-height: 1.5;

  @media(min-width: 768px) {
    width: ${px2Rem(150)};
    font-size: ${TYPOGRAPHY.SIZE.xSmall};
    line-height: 1.42;
  }
`

export const StatitisIcon = Icon.extend`
  margin: 0;
  transform: scale(0.5);

  @media(min-width: 768px) {
    margin-right: ${px2Rem(20)};
    transform: none;
  }
`

export const StatitisDescription = Description.extend`
  margin-bottom: ${px2Rem(5)};
  font-family: ${TYPOGRAPHY.TYPE.base};
  font-size: ${TYPOGRAPHY.SIZE.base};

  @media(min-width: 768px) {
    font-size: ${TYPOGRAPHY.SIZE.xxxLarge};
  }
`

export const StatitisTitle = Title.extend`
  font-size: ${TYPOGRAPHY.SIZE.xxTiny};

  @media(min-width: 768px) {
    font-size: ${TYPOGRAPHY.SIZE.xxSmall};
  }
`



// WEBPACK FOOTER //
// ./src/components/sections/statitis/StatitisResponsive.js